<template>
  <div style="background-color: white">
    <v-row class="primary-pattern">
      <v-row
        align="center"
        justify="center"
        class="mx-0"
        style="background-color: #d0d0d0"
      >
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="pt-6 d-flex justify-center align-center"
        >
          <div>
            <v-img
              src="/quejas/landing-12.png"
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? 'margin-top: 20vh;margin-bottom: 20vh;'
                  : ''
              "
              heigth="20vh"
              width="40vw"
              contain
            ></v-img>
          </div>
        </v-col>
      </v-row>
    </v-row>
    <calidad></calidad>
    <v-container class="pt-12 white">
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12" class="d-flex justify-center align-center">
          <v-card class="mb-12" style="background-color: #f7f7f7" width="100%">
            <v-layout
              :row="$vuetify.breakpoint.mdAndUp"
              class="mx-0"
              :column="$vuetify.breakpoint.smAndDown"
            >
              <v-flex
                xs12
                :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']"
              >
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" class="pr-6">
                      <iframe
                        src="https://docs.google.com/forms/d/e/1FAIpQLScLOoZyXxyjlTuf_EP38Vr4jpsVkzY4OMry2kT1pjP7BZ6YIg/viewform?embedded=true"
                        width="100%"
                        height="1204"
                        frameborder="0"
                        marginheight="0"
                        marginwidth="0"
                        >Cargando…</iframe
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar" :color="snackbarColor">
        {{ snackbarText }}
        <v-btn color="white" dark text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </v-container>
    <v-container style="background-color: white">
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12" class="pt-6 pb-12 d-flex justify-center align-center">
          <div>
            <v-img
              src="/quejas/landing_logotipos.png"
              heigth="auto"
              width="80vw"
              contain
            ></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style scoped>
.primary-pattern {
  height: 60vh;
  background-color: #d0d0d0;
  background-repeat: repeat;
}
.v-application .transparent {
  background-color: #000000 !important;
  border-color: #000000 !important;
}
</style>
<script>
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import axios from "axios";
import Calidad from "../components/Calidad.vue";
export default {
  directives: {
    mask,
  },
  components: { Calidad },
  mounted() {
    this.$store.dispatch("home/setModalImagen", false);
  },
  data: () => ({
    snackbar: false,
    snackbarColor: "info",
    snackbarText: "",
    fromlink: null,
    isLoading: false,
    publicPath: process.env.BASE_URL,
    campusSelected: "",
    offsetTop: 0,
    lic: [
      { key: "Administracion", text: "Admin. de empresas" },
      { key: "Educacion", text: "Ciencias de la educación" },
      { key: "Contaduria", text: "Contaduría" },
      { key: "Comercio", text: "Comercio internacional" },
      { key: "Derecho", text: "Derecho" },
    ],
    states: [
      { key: "AGS", text: "AGUASCALIENTES" },
      { key: "BC", text: "BAJA CALIFORNIA" },
      { key: "BCS", text: "BAJA CALIFORNIA SUR" },
      { key: "CHI", text: "CHIHUAHUA" },
      { key: "CHS", text: "CHIAPAS" },
      { key: "CMP", text: "CAMPECHE" },
      { key: "CMX", text: "CIUDAD DE MEXICO" },
      { key: "COA", text: "COAHUILA" },
      { key: "COL", text: "COLIMA" },
      { key: "DGO", text: "DURANGO" },
      { key: "GRO", text: "GUERRERO" },
      { key: "GTO", text: "GUANAJUATO" },
      { key: "HGO", text: "HIDALGO" },
      { key: "JAL", text: "JALISCO" },
      { key: "MCH", text: "MICHOACAN" },
      { key: "MEX", text: "ESTADO DE MEXICO" },
      { key: "MOR", text: "MORELOS" },
      { key: "NAY", text: "NAYARIT" },
      { key: "NL", text: "NUEVO LEON" },
      { key: "OAX", text: "OAXACA" },
      { key: "PUE", text: "PUEBLA" },
      { key: "QR", text: "QUINTANA ROO" },
      { key: "QRO", text: "QUERETARO" },
      { key: "SIN", text: "SINALOA" },
      { key: "SLP", text: "SAN LUIS POTOSI" },
      { key: "SON", text: "SONORA" },
      { key: "TAB", text: "TABASCO" },
      { key: "TLX", text: "TLAXCALA" },
      { key: "TMS", text: "TAMAULIPAS" },
      { key: "VER", text: "VERACRUZ" },
      { key: "YUC", text: "YUCATAN" },
      { key: "ZAC", text: "ZACATECAS" },
      { key: "OTRO", text: "OTRO..." },
    ],
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
      lic: "",
      horarios: "",
      localidad: "",
      message: "Me interesa toda la información acerca de las promociones",
      licenciatura: false,
      posgrado: false,
      otros: false,
      escolaridad: "",
      school: "",
      state: "",
      other_state: "",
      way: "",
    },
  }),
  computed: {
    ...mapState({}),
    marginTop() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "-15vh";
      } else {
        ("-10vh");
      }
    },
  },
  methods: {
    validateEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone =
        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
    validateFields() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.lic != "" &&
        this.information.localidad != "" &&
        this.information.state != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText =
          "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        this.snackbarColor = "dark";
      }
    },
    submit() {
      this.validateFields();
      if (this.valid) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      this.information.escolaridad = "Promociones";
      if (this.valid && this.emailValid && this.phoneValid) {
        this.sendInfoData();
      }
    },
    sendInfoData() {
      let self = this;
      self.isLoading = true;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("last_grade", "");
      formData.append("phone", this.information.phone);
      formData.append("message", this.information.message);
      formData.append("subject", "Promociones - Informes");
      formData.append("information_by_level", "Licenciatura");
      formData.append("carreer", this.information.lic);
      formData.append("municipality", this.information.state);
      formData.append("birthdate", "");
      formData.append("webpage", "Uva en línea");
      axios({
        method: "post",
        url: "https://www.informes-uva.tidingo.com/api/create-information",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        },
      })
        .then(function (response) {
          if (response.data.status == 200) {
            self.snackbarText =
              "Información enviada, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.clearFields();
          } else {
            self.snackbarText =
              "Ocurrio un error al enviar tu información, intentalo mas tarde";
            self.snackbarColor = "error";
            self.snackbar = true;
            self.clearFields();
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    clearFields() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        carrer: "",
        horarios: "",
        localidad: "",
        message: "Me interesa toda la información acerca de las promociones",
        licenciatura: false,
        posgrado: false,
        otros: false,
        escolaridad: "",
        school: "",
        way: "",
      };
    },
  },
};
</script>
